import { parseSeries } from "views/logic/aggregationbuilder/Series";
import FieldType, { FieldTypes } from "./FieldType";
import FieldTypeMapping from "./FieldTypeMapping";
const typePreservingFunctions = ["avg", "min", "max", "percentile", "latest"];
const constantTypeFunctions = {
  card: FieldTypes.LONG,
  count: FieldTypes.LONG,
  percentage: FieldTypes.PERCENTAGE
};
const inferTypeForSeries = (series, types) => {
  const definition = parseSeries(series.function);
  const newMapping = (type2) => FieldTypeMapping.create(series.function, type2);
  if (definition === null) {
    return newMapping(FieldType.Unknown);
  }
  const { type, field } = definition;
  if (constantTypeFunctions[type]) {
    return newMapping(constantTypeFunctions[type]());
  }
  if (typePreservingFunctions.includes(type)) {
    const mapping = types == null ? void 0 : types.find((t) => t.name === field);
    if (!mapping) {
      return newMapping(FieldType.Unknown);
    }
    return newMapping(mapping.type);
  }
  return newMapping(FieldTypes.FLOAT());
};
export default inferTypeForSeries;
